const state = {
    basicConditions: [
        { id: 0, label: "Zawarcie umowy ubezpieczenia nieruchomości", value: 'Zawarcie umowy ubezpieczenia nieruchomości nr KW .....' },
        { id: 1, label: "Cesja z umowy ubezpieczenia nieruchomości", value: 'Cesja z umowy ubezpieczenia nieruchomości nr KW .....' },
        { id: 2, label: "Przedłożenie FV/rachunków", value: 'Przedłożenie FV/rachunków potwierdzających wydatkowanie kwoty pożyczki' },
        { id: 3, label: "Przedłożenie zaświadczenia z ZUS", value: 'Przedłożenie zaświadczenia z ZUS' },
        { id: 4, label: "Przedłożenie zaświadczenia z US", value: "Przedłożenie zaświadczenia z US" },
        { id: 5, label: "Przedłożenie zgody na wykreślenie hipoteki z nieruchomości", value: 'Przedłożenie zgody na wykreślenie hipoteki z nieruchomości nr KW .....' },
        { id: 6, label: "Przedłożenie innego dokumentu", value: "Przedłożenie innego dokumentu" }
      ]
};

const getters = {
    getAllBasicConditions(state){
        return state.basicConditions
    },
    getBasicConditionById: (state) => (id) => {
        return state.basicConditions.find(condition => condition.id == id);
    }
};

export default {
    state,
    getters
}
